/**
 * Shared label for saved-property dropdowns: KU name, owner surname, type, KU/LV fallback.
 * @param {object} property - row from GET /api/properties
 * @param {(key: string, opts?: object) => string} t - i18n t()
 * @param {{ adminEmailOrIdPrefix?: string }} [opts]
 */
export function formatSavedPropertyLabel(property, t, opts = {}) {
  const kod = property?.kod_ku != null ? String(property.kod_ku).trim() : '';
  const lv = property?.cislo_lv != null ? String(property.cislo_lv).trim() : '';
  const summary = property?.summary && typeof property.summary === 'object' ? property.summary : null;

  const kuName = summary && summary.katastralniUzemi != null ? String(summary.katastralniUzemi).trim() : '';

  let surname = '';
  const primaryName =
    (Array.isArray(summary?.clients) &&
      summary.clients[0] &&
      summary.clients[0].clientName != null &&
      String(summary.clients[0].clientName).trim()) ||
    (summary?.clientName != null ? String(summary.clientName).trim() : '');
  if (primaryName) {
    const nameParts = primaryName.split(/\s+/).filter(Boolean);
    surname = nameParts.length ? nameParts[nameParts.length - 1] : '';
  }

  const typePart = propertyTypeShort(summary, t);

  const kuLvFallback = kod && lv ? `${kod}/${lv}` : kod || lv || t('propertyLabel.incomplete');

  const namePart = kuName ? `${kuName} (${kod})` : kod || '';

  const core = [namePart, lv ? `LV ${lv}` : '', surname, typePart].filter(Boolean).join(' — ');

  const label = core.trim() || kuLvFallback;

  const prefix = opts.adminEmailOrIdPrefix != null ? String(opts.adminEmailOrIdPrefix).trim() : '';
  if (prefix) {
    return `${prefix} — ${label}`;
  }
  return label;
}

/** @param {object|null} summary */
function propertyTypeShort(summary, t) {
  if (!summary) return t('propertyLabel.typeUnknown');
  const vy = summary.vyuziti != null ? String(summary.vyuziti).trim().toLowerCase() : '';

  if (summary.hasUnit) {
    if (vy === 'byt' || vy === 'jednotka') return t('propertyLabel.typeByt');
    if (vy) return t('propertyLabel.typeWithVyuziti', { vyuziti: summary.vyuziti });
    return t('propertyLabel.typeUnit');
  }
  if (summary.hasStavbaOrPozemky) {
    return t('propertyLabel.typeLandOrBuilding');
  }
  return t('propertyLabel.typeUnknown');
}

/**
 * True if this saved row is backed by a parsed LV PDF (apartment flow), not (only) ČÚZK XML cache.
 * @param {object} p
 */
export function isPdfBackedProperty(p) {
  return !!(p?.summary && p.summary.sourcePdf === true);
}
